<i18n>
{
  "en": {
    "title": "Sustainable Building Highlights 2017-2018",
    "description": "Buildings are where we spend much of our lives, and green energy is more important than ever. Learn how we work with customers worldwide to transform buildings for improved energy efficiency, comfort, safety, and reliability. Read about our green building solutions and Marriott's sustainable success story.",
    "ourCustomers": {
      "section": "Our Customers",
      "title": "Building",
      "building": {
        "txtMedia1": {
          "title": "Sustainable buildings highlights",
          "p1": "At Schneider Electric, our global, residential and non-residential Buildings customers make up 43 percent of our business. As the first of our four key markets, buildings are where we spend much of our lives, and energy is omnipresent. Building electricity demand growth accounts for almost 60 percent of total growth in global electricity consumption. This market represents tremendous opportunity for sustainable improvement. Digitalization could cut total energy use in residential and commercial buildings by nearly 10 percent by 2040.<sup>1</sup>",
          "p2": "We work with customers worldwide to transform cities and connect buildings of all sizes for improved energy efficiency, comfort, safety, and reliability. Our innovations are implemented across electrical systems, installation systems, and digital systems to revolutionize building efficiencies and capabilities.",
          "p3": "By connecting devices, systems, and services, EcoStruxure&trade; provides unprecedented access that enables organizations to unlock building value with an open, secure, and scalable platform for building automation, monitoring, and control. We offer connected products, edge control, and apps, analytics, and services, allowing customers to control on-site energy resources and loads to optimize building performance.",
          "p4": "Our solutions help simplify complexity and create buildings of the future — ones that can sense, think, adapt, and become more sustainable."
        },
        "barometer1": {
          "title": "2015 – 2017 Planet <span class='t-nowrap'>&amp; Society</span> barometer achievement",
          "cta": "See the full results",
          "cell1": {
            "title": "Climate & Development (Sustainability offers)",
            "stat": "100%",
            "p1": "of new large customer projects with CO<sub>2</sub> impact quantification"
          }
        },
        "tableTxt": {
          "title": "A sample of our building solutions"
        },
        "table1": {
          "row1": {
            "cell1": {
              "title": "Apps, Analytics &amp; Services"
            },
            "cell3": {
              "title": "EcoStruxure Building Advisor",
              "p1": "Leverage predictive technology solutions and data to increase energy savings and improve reliability."
            }
          },
          "row2": {
            "cell1": {
              "title": "Edge Control"
            },
            "cell3": {
              "title": "EcoStruxure Building Operation and software",
              "p1": "Integrate monitoring, control, and management and improve operations with data collection and analysis."
            }
          },
          "row3": {
            "cell1": {
              "title": "Connected Products"
            },
            "cell3": {
              "title": "Masterpact MTZ air circuit breaker",
              "p1": "Improve performance, power uptime, reliability, and efficiency via new digital capabilities."
            }
          }
        },
        "vid": {
          "title": "Sustainability in a Booming Market",
          "description": "Driving efficiency for the world's largest hotel group"
        },
        "txtMedia2": {
          "title1": "Sustainable building success story: Marriott",
          "title2": "Marriott’s sustainability journey",
          "p1": "Marriott<sup>&reg;</sup> had a bold vision to reduce energy consumption while meeting the rising demand for hotels in China. So, they turned to EcoStruxure Building to create a sustainable, comfortable environment for their guests to offer a world-class experience while achieving 10 to 15 percent energy savings."
        },
        "quote1": {
          "text": "Marriott and Schneider share the same vision — and that's why it becomes much easier for us to reach the same goal, and partner toward that sustainability and energy efficiency for all of our hotels.",
          "author": "Michael Wang",
          "title": "Continent Head, Global Design Asia Pacific,",
          "company": "Marriott Hotel & Resorts and The Ritz-Carlton Hotels"
        },
        "tableTxt2": {
          "title": "Marriott's sustainable solutions"
        },
        "table2": {
          "row1": {
            "cell1": {
              "title": "What",
              "p1": "EcoStruxure Resource Advisor"
            },
            "cell2": {
              "title": "Why",
              "p1": "Instant and secure access to energy and environmental information; collects and centralizes energy and sustainability data for reporting, analysis, and decision making"
            }
          },
          "row2": {
            "cell1": {
              "title": "What",
              "p1": "EcoStruxure Building Operation, EcoStruxure Lighting Expert, EcoStruxure Power Monitoring Expert"
            },
            "cell2": {
              "title": "Why",
              "p1": "User-friendly, integrated software for optimized building performance; maximized system reliability and optimized operational efficiency "
            }
          },
          "row3": {
            "cell1": {
              "title": "What",
              "p1": "Automation servers, network controllers, room controllers, LV / MV switchgear, transformers, power meters, circuit breakers, variable speed drives, UPS, and wiring devices"
            },
            "cell2": {
              "title": "Why",
              "p1": "Building automation and control systems for innovative building management that inspire occupant productivity and deliver optimal energy and operational efficiency"
            }
          }
        },
        "references": {
          "referenceA": "<sup>1</sup> Source: International Energy Agency, Digitalization &amp; Energy 2017"
        },
        "txtFinal": {
          "title": "Recorded benefits to date include:",
          "li1": "10 – 15% energy savings",
          "li2": "Close collaboration ensuring scalable, repeatable hotel technology solutions that meet Marriott<sup>&reg;</sup> brand standards",
          "li3": "Sustainability reporting that will further drive energy and carbon savings across Marriott’s global portfolio of hotels",
          "p1": "<strong>Get the facts on Marriott’s challenges, sustainable solutions, and results.</strong>",
          "ctaText": "Learn more"
        }
      }
    }
  },
  "fr": {
    "title": "Sustainable Building Highlights 2017-2018",
    "description": "Buildings are where we spend much of our lives, and green energy is more important than ever. Learn how we work with customers worldwide to transform buildings for improved energy efficiency, comfort, safety, and reliability. Read about our green building solutions and Marriott's sustainable success story.",
    "ourCustomers": {
      "section": "Nos Clients",
      "title": "Bâtiments",
      "building": {
        "txtMedia1": {
          "title": "Faits marquants bâtiments durables",
          "p1": "Nos clients internationaux du secteur des bâtiments  résidentiels et non résidentiesl représentent 43 % de l’activité de Schneider Electric, soit le premier de nos quatre grands marchés. Les bâtiments sont les lieux dans lesquels nous passons la majeure partie de nos vies, et l’énergie y est omniprésente. La croissance de la demande en électricité dans les bâtiments représente près de 60 % de la croissance de la consommation électrique mondiale. Ce marché dispose d'un potentiel d'optimisation immense sur le plan du développement durable. La numérisation pourrait permettre de réduire la consommation totale d'énergie dans les bâtiments résidentiels et commerciaux de près de 10 % d’ici à 2040. <sup>1</sup>",
          "p2": "Nous travaillons avec nos clients dans le monde entier pour transformer les villes et connecter des bâtiments de toutes tailles pour plus d’efficacité énergétique, de confort, de sécurité et de fiabilité. Nos innovations touchent les systèmes électriques, les systèmes d’installation et les systèmes numériques, et révolutionnent tant l’efficacité que les capacités du bâtiment.",
          "p3": "En connectant les appareils, les systèmes et les services, EcoStruxure<sup>&trade;</sup> propose un accès inégalé à l’information, qui permet aux entreprises de maximiser la valeur de leurs locaux grâce à une plateforme de gestion, de surveillance et de contrôle ouverte, sécurisée et adaptable. Grâce à notre offre de produits connectés, de contrôle local, et d'applications, outils d’analyse et services,  les clients peuvent contrôler leurs ressources et charges énergétiques sur site afin d’optimiser la performance de leurs bâtiments.",
          "p4": "Nos solutions contribuent à réduire la complexité et à façonner les bâtiments de demain &mdash; sensibles, réfléchis, adaptables, plus durables."
        },
        "barometer1": {
          "title": "Résultat du baromètre Planète & Société 2015 &mdash; 2017",
          "cta": "Voir les résultats complets",
          "cell1": {
            "title": "Indicateur Climat et Développement (offres durables)",
            "stat": "100%",
            "p1": "des nouveaux grands projets clients avec une quantification de leur impact CO<sub>2</sub>"
          }
        },
        "tableTxt": {
          "title": "Exemples de nos solutions pour les bâtiments"
        },
        "table1": {
          "row1": {
            "cell1": {
              "title": "Applications, outils d'analyse et services"
            },
            "cell3": {
              "title": "EcoStruxure Building Advisor",
              "p1": "Tirer parti au maximum des solutions technologigues prédictives et des données pour accroître les économies d'énergie et améliorer la fiabilité"
            }
          },
          "row2": {
            "cell1": {
              "title": "Contrôle local (Edge Control)"
            },
            "cell3": {
              "title": "Logiciel EcoStruxure Buiding Operation",
              "p1": "Intégrer le suivi, le contrôle et la gestion et améliorer les installations grâce à la collecte de données et à leur analyse"
            }
          },
          "row3": {
            "cell1": {
              "title": "Produits connectés"
            },
            "cell3": {
              "title": "Le disjoncteur Masterpact MTZ air",
              "p1": "Améliorer la performance, le renforcement de la disponibilité, la fiabilité et l'efficacité grâce à de nouvelles capacités numériques"
            }
          }
        },
        "vid": {
          "title": "Le développement durable dans un marché en plein essor",
          "description": "Prendre en charge l'efficacité du plus grand groupe mondial du secteur de l'hôtellerie"
        },
        "txtMedia2": {
          "title1": "Un exemple de réussite durable chez Marriott",
          "title2": "Marriott et le développement durable",
          "p1": "Marriott a fait le pari audacieux de réduire sa consommation d'énergie tout en répondant à la demande croissante d’hôtels en Chine. Le groupe s’est donc tourné vers EcoStruxure Building afin de créer un environnement confortable et durable pour ses clients, et de leur offrir une expérience de premier ordre tout en réalisant des économies d’énergie de 10 % à 15 %."
        },
        "quote1": {
          "text": "Marriott et Schneider Electric partagent la même vision. C’est pourquoi il nous est plus aisé de viser le même but et de nous associer pour déployer une démarche de développement durable et d’efficacité énergétique dans l’ensemble de nos hôtels",
          "author": "Michael Wang",
          "title": "Directeur Continent, Global Design Asie-Pacifique,",
          "company": "Marriott Hotel & Resorts et les hôtels Ritz Carlton"
        },
        "tableTxt2": {
          "title": "Solutions durables pour Marriott"
        },
        "table2": {
          "row1": {
            "cell1": {
              "title": "Solution",
              "p1": "EcoStruxure Resource Advisor"
            },
            "cell2": {
              "title": "Avantages",
              "p1": "Accès instantané et sécurisé aux informations environnementales et énergétiques ; collecte et centralisation des données relatives à la consommation énergétique et au développement durable aux fins de reporting, d’analyse et de prise de décision"
            }
          },
          "row2": {
            "cell1": {
              "title": "Solution",
              "p1": "EcoStruxure Building Operation, EcoStruxure Lighting Expert, EcoStruxure Power Monitoring Expert"
            },
            "cell2": {
              "title": "Avantages",
              "p1": "Logiciel intégré et convivial pour une performance optimisée du bâtiment ; maximisation de la fiabilité du système et optimisation de l’efficacité opérationnelle"
            }
          },
          "row3": {
            "cell1": {
              "title": "Solution",
              "p1": "Serveurs d’automatisation, contrôleurs de réseau, régulateurs d’ambiance, appareillages BT/MT, transformateurs, wattmètres, disjoncteurs, variateurs de vitesse, ASI et dispositifs de câblage"
            },
            "cell2": {
              "title": "Avantages",
              "p1": "Systèmes de contrôle et d'automatisation pour une gestion innovante du bâtiment qui favorise la productivité de ses occupants et garantit une efficacité énergétique et opérationnelle optimale"
            }
          }
        },
        "references": {
          "referenceA": "<sup>1</sup> Agence internationale de l’énergie, Digitalisation & Energie 2017"
        },
        "txtFinal": {
          "title": "Résultats obtenus à ce jour :",
          "li1": "10 – 15% d'économies d'énergie",
          "li2": "Une collaboration étroite qui garantit des solutions technologiques hôtelières évolutives et reproductibles répondant aux normes de la marque Marriott",
          "li3": "Des rapports de développement durable qui permettront de générer davantage d'économies d'énergie et de carbone dans le portefeuille d'hôtels mondial de Marriott",
          "p1": "<strong>En savoir plus sur les défis de Marriott, solutions durables et résultats</strong>",
          "ctaText": "En savoir plus"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/our-customers/our-customers-building-hero-lowres.jpg')" :hiResSrc="require('../../assets/img/our-customers/our-customers-building-hero.jpg')" chapter="03" :section="$t('ourCustomers.section')" :title="$t('ourCustomers.title')"/>

    <section class="m-b-120 m-t-120">
      <TxtMedia>
        <h2 class="m-b-45" slot="main-content" v-html="$t('ourCustomers.building.txtMedia1.title')"></h2>
        <p slot="main-content" v-html="$t('ourCustomers.building.txtMedia1.p1')"></p>
        <p slot="main-content" v-html="$t('ourCustomers.building.txtMedia1.p2')"></p>
        <p slot="main-content" v-html="$t('ourCustomers.building.txtMedia1.p3')"></p>
        <p id="buildings" slot="main-content" v-html="$t('ourCustomers.building.txtMedia1.p4')"></p>
        <div slot="sidebar" class="l-mw-360 l-center">
          <SvgContainer v-if="$i18n.locale === 'en'">
            <OCBuildingIG class="scaling-svg" />
          </SvgContainer>
          <SvgContainer v-if="$i18n.locale === 'fr'" >
            <OCBuildingIGFR class="scaling-svg" />
          </SvgContainer>
        </div>
      </TxtMedia>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('ourCustomers.building.barometer1.title')"></h2>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('ourCustomers.building.barometer1.cta')" target="_blank"/>
        <BarometerIndicator class="col-xs-18" color="#059941" :title="$t('ourCustomers.building.barometer1.cell1.title')" :stat="$t('ourCustomers.building.barometer1.cell1.stat')" :body="$t('ourCustomers.building.barometer1.cell1.p1')"></BarometerIndicator>
      </Barometer>
    </section>

    <section class="l-bg-white l-section-pad">
      <Table columns="3">
        <h2 id="buildingsolutions" slot="above" v-html="$t('ourCustomers.building.tableTxt.title')"></h2>
        <TableRow>
          <TableCell bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.building.table1.row1.cell1.title')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/EcoStruxure-Building-Advisor.jpg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.building.table1.row1.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table1.row1.cell3.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 class="t-green-light" v-html="$t('ourCustomers.building.table1.row2.cell1.title')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/EcoStruxure-Building-Operation.jpg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.building.table1.row2.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table1.row2.cell3.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.building.table1.row3.cell1.title')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/our-customers-building-tablecell-img-03.jpeg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.building.table1.row3.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table1.row3.cell3.p1')"></p>
          </TableCell>
        </TableRow>
      </Table>
    </section>

    <section class="m-b-120 m-t-120">
      <YouTubeVideo class="m-b-80" videoId="8DepeiCCkVo" :title="$t('ourCustomers.building.vid.title')" :description="$t('ourCustomers.building.vid.description')" :preview="require('@/assets/img/thumbnails/Marriot.jpg')" />
      <TxtMedia>
        <h2 id="marriottstory" class="m-b-15" slot="main-content" v-html="$t('ourCustomers.building.txtMedia2.title1')"></h2>
        <h3 class="m-b-15" slot="main-content" v-html="$t('ourCustomers.building.txtMedia2.title2')"></h3>
        <p slot="main-content" v-html="$t('ourCustomers.building.txtMedia2.p1')"></p>
        <img slot="sidebar" src="@/assets/img/our-customers/our-customers-building-marriott.jpg" />
      </TxtMedia>
    </section>

    <section class="l-bg-white l-section-pad m-b-50">
      <Table class="m-b-50" columns="2">
        <h2 id="marriottsolutions" slot="above" v-html="$t('ourCustomers.building.tableTxt2.title')"></h2>
        <TableRow>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.building.table2.row1.cell1.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table2.row1.cell1.p1')"></p>
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.building.table2.row1.cell2.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table2.row1.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 v-html="$t('ourCustomers.building.table2.row2.cell1.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table2.row2.cell1.p1')"></p>
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.building.table2.row2.cell2.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table2.row2.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.building.table2.row3.cell1.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table2.row3.cell1.p1')"></p>
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.building.table2.row3.cell2.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.building.table2.row3.cell2.p1')"></p>
          </TableCell>
        </TableRow>
      </Table>

      <Txt class="m-b-50">
        <h3 v-html="$t('ourCustomers.building.txtFinal.title')"></h3>
        <ul>
          <li v-html="$t('ourCustomers.building.txtFinal.li1')"></li>
          <li v-html="$t('ourCustomers.building.txtFinal.li2')"></li>
          <li v-html="$t('ourCustomers.building.txtFinal.li3')"></li>
        </ul>
      </Txt>

      <Quote class="m-b-50" :name="$t('ourCustomers.building.quote1.author')" :title="$t('ourCustomers.building.quote1.title')" :company="$t('ourCustomers.building.quote1.company')" :photo="require('@/assets/img/our-customers/Michael-Wang_Marriot.jpg')">
        <div v-html="$t('ourCustomers.building.quote1.text')"></div>
      </Quote>

      <Txt>
        <p v-html="$t('ourCustomers.building.txtFinal.p1')" class="t-grey"></p>
        <CTA target="_blank" :buttonText="$t('ourCustomers.building.txtFinal.ctaText')" href="https://www.schneider-electric.com/en/work/campaign/life-is-on/case-study/marriott-hotel-china.jsp"></CTA>
      </Txt>
    </section>

    <References class="m-b-30">
      <Reference v-html="$t('ourCustomers.building.references.referenceA')"/>
    </References>

    <FooterNav
      nextRoute="OurCustomers_DataCenter"
      prevRoute="OurCustomers_Overview" />

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import TxtMedia from '@/components/TxtMedia'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import ImageFull from '@/components/ImageFull'
import References from '@/components/References'
import Reference from '@/components/Reference'
import SvgContainer from '@/components/SvgContainer'
import YouTubeVideo from '@/components/YouTubeVideo'

import OCBuildingIG from '@/assets/img/ig/our-customers-building-highlights.svg'
import OCBuildingIGFR from '@/assets/img/ig/our-customers-building-highlights_french.svg'

export default {
  name: 'OurCustomers_Building',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    TxtMedia,
    Table,
    TableRow,
    TableCell,
    Barometer,
    BarometerIndicator,
    ImageFull,
    References,
    Reference,
    SvgContainer,
    OCBuildingIG,
    OCBuildingIGFR,
    YouTubeVideo
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/our-customers/building.vue